import type {ScheduleDateToSaveOptions} from './schedule-form.types';

export function clampToMinAllowedDate(date: Date | null, minAllowedDate: Date): Date {
  if (date !== null && date.getTime() >= minAllowedDate.getTime()) {
    return date;
  }

  return minAllowedDate;
}

export function getScheduleDateToSave({isBestTimeEnabled, optimalSendTime, hasUserChosenDateTime, currentDateTime, minAllowedDate}: ScheduleDateToSaveOptions): Date {
  if (isBestTimeEnabled && optimalSendTime) {
    return optimalSendTime;
  }

  if (hasUserChosenDateTime) {
    return currentDateTime;
  }

  return clampToMinAllowedDate(currentDateTime, minAllowedDate);
}
